import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Toggle} from 'componentLibrary';
import {
  Card,
  Container,
  Divider,
  Breadcrumb,
  Icon,
  Grid,
  Header,
  Loader,
  Dimmer,
  Segment,
  GridColumn,
} from 'semantic-ui-react';
import {
  canViewAwardsTracker,
  canViewBucketTracker,
  hasGeneralPermission,
} from 'go/security/permissions';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import MyOpenTasks from 'go/pages/taskSummary/myOpenTasks';
import MyOfficeWorkload from 'go/pages/taskSummary/myOfficeWorkload';
import {Alert} from 'componentLibrary';
import UnassignedSummary from 'go/pages/taskSummary/unassignedSummary';
import {CLEAR_COMPLETED_TASK} from 'common/types';
import {getUserEntitiesForEntityType} from 'common/utils';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';
import {TASK_SUMMARY_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import REST from 'go/requests/rest';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class TaskSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      isDisasterOnly: null,
    };
  }

  componentDidMount() {
    document.title = TASK_SUMMARY_PAGE;
    this.props.clearCompletedTask();
    this.fetchIsDisasterOnly();
  }

  async fetchIsDisasterOnly() {
    const token = this.props.token;
    const programIds = getUserEntitiesForEntityType(
      this.props.permissions,
      ENTITY_MAP.PROGRAM.code
    );
    if (programIds && programIds.length > 0) {
      const programIdsStr = programIds.join(',');
      REST.program
        .getProgramsbyIds(token, programIdsStr)
        .then((response) => forceJsonResponse(response, FLUX))
        .then(async (resJson) => {
          const isNonDisaster = resJson.some((program) => {
            return program.disasterFlag === false;
          });
          this.setState({isDisasterOnly: !isNonDisaster}, () => {
            this.checkFos();
          });
        })
        .catch(async (error) => {
          console.error('error', {error});
          this.setState({isDisasterOnly: false});
          await this.checkFos();
        });
    } else {
      await this.checkFos();
    }
  }

  async checkFos() {
    const fos = getUserEntitiesForEntityType(
      this.props.permissions,
      ENTITY_MAP.FUNDING_OPPORTUNITY.code
    );

    if (fos && fos.length > 0) {
      if (this.state.isDisasterOnly === true || this.state.isDisasterOnly === null) {
        for (let i = 0; i < fos.length; i++) {
          const fo = fos[i];
          try {
            const res = await REST.fundingOpportunity.getFundingOpportunity(
              this.props.token,
              fo
            );
            const resJson = await forceJsonResponse(res, MONO);
            const isDisasterOnly = _.get(
              resJson,
              'configData.foOverview.isDisasterFO',
              false
            );
            this.setState({isDisasterOnly});
            if (isDisasterOnly === false) {
              break;
            }
          } catch (error) {
            this.setState({isDisasterOnly: false});
          }
        }
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let task = _.get(nextProps, 'context.task');
    let status = _.get(nextProps, 'context.status');

    if (task) {
      prevState.defaultTab = task.taskDefinitionKey;
      if (status) {
        let name = task.name.toLowerCase();
        let grantId = _.get(nextProps, 'context.processVariables.grantId');
        let subGrantId = _.get(
          nextProps,
          'context.processVariables.subApplication.subGrantId'
        );
        let entityId = subGrantId ? subGrantId : grantId;
        prevState.message = `You ${status.outcomeMessage} ${name}${
          entityId ? ` for ${entityId}` : ''
        }`;
      }
    } else {
      prevState.defaultTab = '';
    }
    return prevState;
  }

  renderAlert = (message) => {
    if (message) {
      return <Alert header={message} type="success" dismissable />;
    }
  };

  render() {
    const {message} = this.state;
    const businessObjectivesCard = (
      <GridColumn>
        {' '}
        <Card>
          <Card.Content>
            <Header as="h3">Awards Tracker</Header>
            <Card.Description>
              <Link to={'/awardsTracker'} title="View awards tracker">
                View &gt;
              </Link>
            </Card.Description>
          </Card.Content>
        </Card>
      </GridColumn>
    );

    return (
      <Main>
        <Container fluid>
          {this.renderAlert(message)}
          <Header as="h1">Task Summary</Header>
          <Grid columns={4} doubling stackable padded="vertically">
            <Grid.Row>
              <Grid.Column>
                <MyOpenTasks />
              </Grid.Column>
              {this.state.isDisasterOnly === false &&
              (canViewAwardsTracker(this.props.permissions, this.props.token) ||
                hasGeneralPermission('BUSINESS_OBJECTIVES_TRACKER'))
                ? businessObjectivesCard
                : null}
              <Grid.Column>
                <MyOfficeWorkload />
              </Grid.Column>
            </Grid.Row>
            <UnassignedSummary />
          </Grid>
        </Container>
      </Main>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  clearCompletedTask: () => {
    dispatch({
      type: CLEAR_COMPLETED_TASK,
    });
  },
});

export const mapStateToProps = (state) => {
  return {
    context: state.dynamicComponent.context.workflowTask,
    permissions: state.auth ? state.auth.permissions : [],
    toggles: state.toggles.toggles,
    token: state.auth.token,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskSummary);
